export default __webpack_public_path__ + "static/media/runnerup3.ef36f26b.jpg";